/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {JsonLdItem} from '@/store/types';

/**
 * Game module state interface.
 * Represents a animal module including the currently selected animal.
 */
export interface GameStateInterface {
    species: SpeciesInterface[];
    dlc: DlcInterface[];
    favourites: FavouritesInterface[];
    tweakables: TweakablesInterface;
    zoo: string;
    cash: number;
    locked: boolean;
}

/**
 * Game module state class.
 * Provides initial state.
 */
export class GameState implements GameStateInterface {
    public species: SpeciesInterface[] = [];
    public dlc: DlcInterface[] = [];
    public favourites: FavouritesInterface[] = [];
    public tweakables: TweakablesInterface = {gradeGold: 73, gradeSilver: 70.9, gradeBronze: 66.6};
    public zoo: string = '';
    public cash: number = 0;
    public locked: boolean = false;
}

/**
 * Species interface representing a supported species.
 */
export interface DlcInterface extends JsonLdItem {
    id: string;
    description: string;
}

/**
 * Species interface representing a supported species.
 */
export interface SpeciesInterface extends JsonLdItem {
    id: string;
    commonName: string;
    binomialName: string;
    juvenileAge: number;
    fullMaturityAge: number;
    infertileAge: number;
    purchaseCost: number;
    medals: MedalsCategoriesInterface;
    dlc: string;
}

/**
 * Medals categories interface representing species medals.
 */
export interface MedalsCategoriesInterface {
    adopt: MedalsInterface;
    breed: MedalsInterface;
    exchange: MedalsInterface;
    release: MedalsInterface;
    [key: string]: MedalsInterface;
}

/**
 * Medals interface to represent a medal threshold award for a species
 */
export interface MedalsInterface {
    B: number;
    S: number;
    G: number;
    [key: string]: number;
}

/**
 * Favourites interface representing a user favourite.
 */
export interface FavouritesInterface extends JsonLdItem {
    animal: string;
}

/**
 * Representation of tweakable data.
 */
export interface TweakablesInterface {
    gradeGold?: number;
    gradeSilver?: number;
    gradeBronze?: number;
    [key: string]: number|undefined;
}

/**
 * Game Api Call interface.
 * Used to call the game API protocol.
 */
export interface GameApiCallInterface {
    route: string;
    base?: string;
    params?: undefined|{[key: string]: string|number};
}

/**
 * Audio Api Call interface.
 * Used to call the game API protocol.
 */
export interface AudioApiCallInterface {
    type: string;
    params?: undefined|{[key: string]: string|number};
}
